var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12001 9.29001L12 13.17L15.88 9.29001C15.9726 9.19742 16.0825 9.12399 16.2035 9.07388C16.3244 9.02378 16.4541 8.99799 16.585 8.99799C16.7159 8.99799 16.8456 9.02378 16.9666 9.07388C17.0875 9.12399 17.1974 9.19742 17.29 9.29001C17.3826 9.38259 17.456 9.4925 17.5061 9.61346C17.5562 9.73443 17.582 9.86408 17.582 9.99501C17.582 10.1259 17.5562 10.2556 17.5061 10.3765C17.456 10.4975 17.3826 10.6074 17.29 10.7L12.7 15.29C12.31 15.68 11.68 15.68 11.29 15.29L6.70001 10.7C6.60731 10.6075 6.53376 10.4976 6.48358 10.3766C6.4334 10.2557 6.40757 10.126 6.40757 9.99501C6.40757 9.86404 6.4334 9.73436 6.48358 9.61338C6.53376 9.49241 6.60731 9.38252 6.70001 9.29001C7.09001 8.91001 7.73001 8.90001 8.12001 9.29001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/drop-down.b0489ba79aa3dbcfb354f17a6d87596e.svg";
export { ForwardRef as ReactComponent };